// @flow

import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

const ResultsTable = styled.ul`
  background-color: ${buildColor("white", "100")};
  list-style: none;
  width: 100%;
  border-bottom: 1px solid ${buildColor("grey", "L2")};
`;

export default ResultsTable;
